<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >

    <v-toolbar-title>상품 리스트 </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_ShowPopup_CreateProductCoin"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>  
    </v-toolbar>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="coin_list"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+row.item.THUMB_IMG" alt="Image"  style="width: 60px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
            <td>{{row.item.COIN_NM}}</td>
            <td>{{formatCoin(row.item.PRODUCT_PRICE)}}</td>
            <td>  <span :style="{ fontWeight: '900', color: row.item.ENABLE == 'Y' ? 'blue' : 'red' }">{{row.item.ENABLE}}</span></td>
            <td>  <span :style="{ fontWeight: '900', color: row.item.DESTINATION_TAG == 'Y' ? 'blue' : 'red' }">{{row.item.DESTINATION_TAG}}</span></td>
            <td>  <span>{{row.item.TAX_PER}}</span></td>
            <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClick_ShowPopup_EditCoin(row.item)">수정하기</v-btn>
            </td>
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog_popup"
      max-width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'상품 등록하기 '}}
        </v-card-title>
        <v-card-text>
            <v-row>
        <v-col cols="12" sm="3"  class="text-center font-weight-bold text-h6">상품  아이콘</v-col>
      <!-- 왼쪽: 이미지 업로드 입력 -->
       <v-col v-if="dialog_selected_item != null" cols="12" sm="3"
        <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+dialog_selected_item.THUMB_IMG" alt="Image"  style="width: 60px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
       </v-col>
      <v-col cols="12" md="6">
        <v-file-input
          label="상품 아이콘 (128 * 128)"
          accept="image/*"
          v-model="dialog_IconImageFile"
          prepend-icon="mdi-image"
          outlined
          @change="handleFileChange"
        />
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="3"  class="text-center font-weight-bold text-h6">상품 타입</v-col>

        <v-col v-if="dialog_mode_is_create" class="d-flex align-center">
            <v-select
            v-model="dialog_dropdown_selected"
            :items="dropdown_items"
            label="선택하세요"
            outlined
            dense
            hide-details
            style="width: 100%"
            ></v-select>
        </v-col>
        <v-col v-else  cols="12" sm="3"  class="text-center font-weight-bold text-h6">{{dialog_dropdown_selected}}</v-col> 
    </v-row>
    <v-row  v-if="dialog_dropdown_selected == 'COIN'" >
        <v-col cols="12" sm="3"  class="text-center font-weight-bold text-h6">코인 태그</v-col>
        <v-col v-if="dialog_mode_is_create">
            <v-text-field 
                label="코인고유 태그를 입력해주세요(EX:BTC)"
                v-model="dialog_coin_tag" 
                outlined
                dense
            ></v-text-field></v-col>
        <v-col v-else class="font-weight-bold text-h6">
            {{ dialog_selected_item.COIN_TAG }}
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="3"  class="text-center font-weight-bold text-h6">상품 이름</v-col>
        <v-col v-if="dialog_mode_is_create"><v-text-field 
                label="상품 이름을 입력해주세요"
                v-model="dialog_coin_name" 
                outlined
                dense
            ></v-text-field>
        </v-col>
        <v-col v-else class="font-weight-bold text-h6">
            {{ dialog_selected_item.COIN_NM }}
        </v-col>
    </v-row>
    <v-row>
        <v-col  cols="12" sm="3"  class="text-center font-weight-bold text-h6">한화 가격</v-col>
        <v-col>
        <v-text-field 
                label="한화 가격 입력"
                v-model="dialog_coin_price" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col  cols="12" sm="6"  class="text-center font-weight-bold text-h6">세금+수수료Per(0 ~ 1)</v-col>
        <v-col>
        <v-text-field 
                label="수수료+세금입력"
                v-model="dialog_tax_per" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col  cols="12" sm="5"  class="text-center font-weight-bold text-h6">활성화 여부</v-col>
        <v-col>
            <v-checkbox
      v-model="dialog_coin_enable"
      label="(활성화 유무)"
      class="my-auto"
    ></v-checkbox>
        </v-col>
    </v-row>
    <v-row  v-if="dialog_dropdown_selected == 'COIN'" >
        <v-col  cols="12" sm="5"  class="text-center font-weight-bold text-h6">데스니티태그 사용여부</v-col>
        <v-col>
            <v-checkbox
      v-model="dialog_coin_destination_tag"
      label="(데스티네이션태그 유무)"
      class="my-auto"
    ></v-checkbox>
        </v-col>
    </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="OnClick_ClosePopup"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="OnClick_EditProductCoin"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [            
            { text: '아이콘', value: 'icon' },
            { text: '이름', value: 'name' },
            { text: '한화가격', value: 'kw_price' },            
            { text: '활성화', value: 'enable' },
            { text: '데스티네이션 태그', value: 'destination_tag' },
            { text: '세금/수수료 Per', value: 'tax_per' },
            { text: '수정하기', value: 'edit' },
        ],
        coin_list:[],
        total_count:0,
        dialog_selected_item: null,
        dialog_popup:false ,
        dialog_coin_thumb_path:'', 
        dialog_coin_tag:'',
        dialog_coin_name:'',
        dialog_coin_price:0,
        dialog_coin_enable:true, 
        dialog_coin_destination_tag:false,
        dialog_mode_is_create:true,
        dialog_IconImageFile:null,

        dialog_dropdown_selected:null,
        dropdown_items: ['COIN', 'CASH'],

    }),

    created()
    {
        console.log("TEST");
        this.Load_CoinList();
    },

    methods:{
        ...mapActions([
            'QUIZANDCASH_GET_SWAP_COIN_LIST',
            'QUIZANDCASH_CREATE_SWAP_COIN_INFO',
            'QUIZANDCASH_EDIT_SWAP_COIN_INFO',
        ]),
        Load_CoinList()
        {
            this.QUIZANDCASH_GET_SWAP_COIN_LIST({}).then((body_data)=>{
                this.coin_list = body_data.coin_list;f
                console.log(JSON.stringify(  this.coin_list));
            });
        },
        OnClick_ShowPopup_CreateProductCoin(){
            this.dialog_selected_item = null;
            this.dialog_popup = true;
            this.dialog_mode_is_create = true;
            this.dialog_coin_tag = '';
            this.dialog_coin_thumb_path = '';
            this.dialog_coin_name = '';
            this.dialog_coin_price = 0;
            this.dialog_coin_enable = true;
            this.dialog_coin_destination_tag = false;
            this.dialog_IconImageFile = null;
            this.dialog_dropdown_selected = null;
        },
        async OnClick_EditProductCoin() {
            //coin_tag ,thumb_img, coin_nm , coin , snap_coin_price , destination_tag , enable_state
            let coin_tag = this.dialog_coin_tag;

            let coin_nm = this.dialog_coin_name;
            let product_price = this.dialog_coin_price;
            let snap_coin_price = product_price/50000.0;
            let destination_tag = this.dialog_coin_destination_tag? "Y":"N";
            let enable_state = this.dialog_coin_enable ? "Y":"N";
            let tax_per = this.dialog_tax_per;
            let type = this.dialog_dropdown_selected;
            if(this.dialog_mode_is_create){
                if(this.dialog_IconImageFile == null){
                    alert("필수항목 누락");
                    return;
                }
            }
            if(type == null){
                alert("필수항목 누락");
                return;
            }
            if(type == "CASH"){
                coin_tag = "CASH";
            }
            if(coin_tag == "" || coin_nm == ""){
                alert("필수항목 누락");
                return;
            }
            if(this.dialog_mode_is_create) { //생성일때 
                this.dialog_coin_thumb_path = "project_cpu/coin/images/"+this.Utill_CreateNewImageName(this.dialog_IconImageFile.name);
                const awaitResult = await FileUpload_Async(this.dialog_IconImageFile, this.dialog_coin_thumb_path);
            }
            else
            {// 수정일때는 파일이 있을때만 
                //this.dialog_coin_thumb_path = this.dialog_selected_item.THUMB_IMG;
                if(this.dialog_IconImageFile != null){
                    this.dialog_coin_thumb_path = "project_cpu/coin/images/"+this.Utill_CreateNewImageName(this.dialog_IconImageFile.name);
                    const awaitResult = await FileUpload_Async(this.dialog_IconImageFile, this.dialog_coin_thumb_path);
                }
            }
              

            let thumb_img  = this.dialog_coin_thumb_path;
            if( this.dialog_mode_is_create ){
                this.QUIZANDCASH_CREATE_SWAP_COIN_INFO({coin_tag ,thumb_img, coin_nm , product_price , snap_coin_price , tax_per,  destination_tag , enable_state, type}).then((body_data)=>{
                        this.Load_CoinList();
                    });
            } else {
                let pid = this.dialog_selected_item.PID;
                //,pid  , thumb_img , coin , snap_coin_price, destination_tag , enable_state 
                //admin_user, pid , thumb_img , coin , snap_coin_price, destination_tag , enable_state
                this.QUIZANDCASH_EDIT_SWAP_COIN_INFO({ pid, thumb_img,  product_price , snap_coin_price, tax_per , destination_tag , enable_state}).then((body_data)=>{
                    this.Load_CoinList();
                });
            }          
            this.OnClick_ClosePopup();
        },
        OnClick_ShowPopup_EditCoin(item)
        {
            this.dialog_selected_item = item;
            this.dialog_popup = true;
            this.dialog_mode_is_create = false;
            this.dialog_coin_tag = this.dialog_selected_item.COIN_TAG;
            this.dialog_coin_thumb_path = this.dialog_selected_item.THUMB_IMG;
            this.dialog_coin_name = this.dialog_selected_item.COIN_NM;
            this.dialog_coin_price = this.dialog_selected_item.PRODUCT_PRICE;
            this.dialog_tax_per = this.dialog_selected_item.TAX_PER;
            this.dialog_coin_enable = this.dialog_selected_item.ENABLE == "Y"?true:false;
            this.dialog_coin_destination_tag = this.dialog_selected_item.DESTINATION_TAG == "Y"?true:false;
            this.dialog_IconImageFile = null;
            this.dialog_dropdown_selected = this.dialog_selected_item.TYPE;
        },
    
        OnClick_ClosePopup()
        { 
            this.dialog_popup = false;
        },
        handleFileChange(file)
        {
            this.dialog_IconImageFile = file;            
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
        formatCoin(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString();
        }
    },
    computed: {
        
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
@media (max-width: 600px) {
    .v-data-table {
        overflow-x: auto;
    }
    .v-toolbar__content {
        flex-wrap: wrap;
        height: auto !important;
        padding: 8px;
        gap: 4px;
    }
}
</style>
